import { render, staticRenderFns } from "./DetailTreeItemCard.vue?vue&type=template&id=28e43944&scoped=true&"
import script from "./DetailTreeItemCard.vue?vue&type=script&lang=js&"
export * from "./DetailTreeItemCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailTreeItemCard.vue?vue&type=style&index=0&id=28e43944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e43944",
  null
  
)

export default component.exports